const paymentwall = {


    initialize: () => {
        let brick = new Brick({
            public_key: '9bda9743b16379d350d3fce1034e6b3e',
            form: { formatter: true }
        }, 'custom');

        return brick;
    },

    tokenize: (brick, card, _callback) => {
        console.log({
            card_number: card.cardNumber,
            card_expiration_month: card.cardExpirationMonth,
            card_expiration_year: card.cardExpirationYear,
            card_cvv: card.securityCode
        });
        brick.tokenizeCard({
            card_number: card.cardNumber,
            card_expiration_month: card.cardExpirationMonth,
            card_expiration_year: card.cardExpirationYear,
            card_cvv: card.securityCode
        }, function (response) {
            if (response.type == 'Error') {
                // handle errors
                console.log('deu ruim');
                console.log(response);
                _callback();
            } else {
                _callback({token: response.token, fingerprint: Brick.getFingerprint()})
            }
        });
    },

    /**
     * @param array data
     * @return mixed
     */
    checkout: (data, _callback) => {

        $.post('/api/v2/ebanx-token?lng=' + helperFunctions.getLangInUrl() + "&fp=" + data._id, data).then(function (response) {
            _callback(response);
        }, function (response) {
            _callback();
        });
    }

}

export default paymentwall;